import React, { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import JoditEditor from "jodit-react";
import { fetchApi } from "../../utlis/axios";
import { toast } from "react-toastify";
import { IoMdClose } from "react-icons/io";

const BlogsEditor = ({ onClose, updateBlogs }) => {
  const url = process.env.REACT_APP_API_URL;
  const theme = "light";
  const { userInfo } = useSelector((state) => state?.authSlice || {});

  const [isLoading, setIsLoading] = useState(false);
  const [isFileUplaoding, setFileUploading] = useState("");
  const {
    handleSubmit,
    formState: { errors },
  } = useForm();
  const cataGories = [
    "Technology",
    "Time Scheduling",
    "Project Management",
    "Activity Tracking",
    "Team Managment",
    "Scehduling",
  ];
  const [tags, setTags] = useState([]);
  const [title, setTitle] = useState("");
  const [newTag, setNewTag] = useState(null);
  const [content, setContent] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [metaDescription, setMetaDescription] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [altText, setAltText] = useState("");
  const [blogUrl, setBlogUrl] = useState("");
  const [keywords, setKeywords] = useState([]);
  const [newKeyWord, setNewKeyword] = useState(null);
  const [isDropdownOpen, setIsDropDownOpen] = useState(false);
  const editor = useRef(null);
  const dispatch = useDispatch();
  const [isAttachmentUploading, setIsAttachmentUploading] = useState(false);
  const [attachmentPreview, setAttachmentPreview] = useState(null);

  const handleSubmitForm = async () => {
    if (!title || !content || !metaDescription) {
      toast.error("Please fill all the fields");
      return;
    }
    if (isFileUplaoding) {
      toast.warn("Please Wait image uploading in processing");
      return;
    }
    if (attachments.length === 0) {
      toast.error("Please attach cover image");
      return;
    }
    if (!selectedCategory) {
      toast.error("Please select category");
      return;
    }
    if (!tags.length || !keywords.length) {
      toast.error("Please select one tag");
      return;
    }
    if (!altText || !blogUrl) {
      toast.error("Please add alt text");
      return;
    }
    setIsLoading(true);
    try {
      const res = await fetchApi.post(
        "blogs/",
        {
          title: title,
          description: content,
          tags: {
            tags: tags,
            meta_description: metaDescription,
            catagory: selectedCategory,
            keywords: keywords,
            alt_text: altText,
            blog_url: blogUrl,
          },
          attachments: [...attachments],
          is_active: true,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo?.access}`,
          },
        }
      );
      if (res.status === 201) {
        toast.success("Blog posted successfully");
        updateBlogs();
        setTags(null);
        setTitle("");
        setContent("");
        setMetaDescription("");
        setAttachments([]);
        setSelectedCategory(null);
        onClose();
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileChange1 = async (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = () => setAttachmentPreview(reader.result);
        reader.readAsDataURL(file);
      } else {
        setAttachmentPreview(file.name);
      }

      const formData = new FormData();
      formData.append("file", file);
      formData.append("created_by", userInfo?.user.id);
      setIsAttachmentUploading(true);

      try {
        setFileUploading(true);
        const response = await fetchApi.post("/attachments/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            // Authorization: `Bearer ${userInfo?.access}`,
          },
        });

        if (response.status === 201) {
          setAttachments((prev) => [...prev, response.data.id]);
        } else {
          toast.error("File Upload failed");
        }
      } catch (error) {
        toast.error("Something went wrong");
      } finally {
        setFileUploading(false);
        setIsAttachmentUploading(false);
      }
    }
  };

  const editorConfig = {
    readonly: false,
    theme: theme === "dark" ? "dark" : "default",
    cleanHTML: {
      cleanOnPaste: false,
    },
    askBeforePasteHTML: true,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: "insert_as_html",
    uploader: {
      insertImageAsBase64URI: false,
      url: `${url}attachments/`,
      format: "json",
      method: "POST",
      headers: {
        Authorization: `Bearer ${userInfo?.access}`,
      },
      filesVariableName: () => "file",
      prepareData: (formData) => {
        formData.append("created_by", userInfo?.user.id);
        return formData;
      },
      isSuccess: (resp) => resp?.file,
      process: (resp) => ({
        files: [resp.file],
        path: resp.file,
        baseurl: url,
      }),
      defaultHandlerSuccess: function (data) {
        if (data.files && data.files.length) {
          const jodit = this;
          data.files.forEach((file) => {
            if (file.match(/\.(jpeg|jpg|gif|png|webp)$/) != null) {
              jodit.s.insertImage(file);
            } else {
              const fileName = file.split("/").pop();
              jodit.s.insertHTML(`<a href="${file}" download>${fileName}</a>`);
            }
          });
          return false;
        }
        return data.path;
      },
      error: (e) => {
        toast.error("File uplaod failed");
        return false;
      },
    },
    buttons: [
      "bold",
      "italic",
      "underline",
      "|",
      {
        args: ["One"],
        name: "button",
        list: ["One", "Two", "Three"],
        exec: (editor, current, btn) => {
          const value = btn.control.args[0];
          editor.selection.insertHTML(value);
        },
      },
      "ol",
      "ul",
      // ... rest of your buttons
    ],
  };

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 z-[1000]"></div>
      <div className="w-full h-full max-h-[100vh] overflow-y-scroll z-[1010] inset-0 fixed px-4 py-4">
        <div className="flex min-h-full items-center justify-center">
          <div className="flex items-center justify-center w-full">
            <div
              className={`rounded-[20px] shadow-xl px-8 py-6 w-full max-w-4xl ${
                theme === "dark" ? "bg-[#212529]" : "bg-[#F9FAFB]"
              }`}
            >
              <div className="flex justify-between items-center mb-4">
                <h2
                  className={`text-2xl font-bold w-full text-center ${
                    theme === "dark" ? "text-white" : "text-gray-900"
                  }`}
                >
                  Create New Blog
                </h2>
                <button
                  onClick={onClose}
                  className="bg-primary-green text-white p-1 rounded-full w-max"
                >
                  <IoMdClose size={24} />
                </button>
              </div>

              <form onSubmit={handleSubmit(handleSubmitForm)}>
                {/* Title Field */}
                <div className="mb-4">
                  <label
                    className={`block mb-2 ${
                      theme === "dark" ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Title*
                  </label>
                  <input
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    className={`w-full px-3 py-2 border rounded-lg ${
                      theme === "dark"
                        ? "bg-[#404347] text-white border-gray-600 focus:border-gray-400"
                        : "bg-white text-gray-900 border-gray-300 focus:border-gray-500"
                    }`}
                    placeholder="Blog title"
                  />
                  {errors.title && (
                    <p className="text-red-500 text-sm mt-1">
                      Title is required
                    </p>
                  )}
                </div>

                {/* Rich Text Editor */}
                <div className="mb-4">
                  <label
                    className={`block mb-2 ${
                      theme === "dark" ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Content*
                  </label>
                  <JoditEditor
                    ref={editor}
                    value={content}
                    config={editorConfig}
                    tabIndex={1}
                    onChange={(newContent) => setContent(newContent)}
                  />
                </div>

                {/* Meta Description */}
                <div className="mb-4">
                  <label
                    className={`block mb-2 ${
                      theme === "dark" ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Meta Description
                  </label>
                  <input
                    type="text"
                    value={metaDescription}
                    onChange={(e) => setMetaDescription(e.target.value)}
                    className={`w-full px-3 py-2 border rounded-lg ${
                      theme === "dark"
                        ? "bg-[#404347] text-white border-gray-600"
                        : "bg-white text-gray-900 border-gray-300"
                    }`}
                  />
                </div>

                {/* Category Dropdown */}
                <div className="mb-4 relative">
                  <label
                    className={`block mb-2 ${
                      theme === "dark" ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Category
                  </label>
                  <div
                    onClick={() => setIsDropDownOpen(!isDropdownOpen)}
                    className={`w-full px-3 py-2 border rounded-lg cursor-pointer ${
                      theme === "dark"
                        ? "bg-[#404347] text-white border-gray-600"
                        : "bg-white text-gray-900 border-gray-300"
                    }`}
                  >
                    {selectedCategory || "Select a category"}
                  </div>
                  {isDropdownOpen && (
                    <div
                      className={`absolute w-full mt-1 rounded-lg shadow-lg z-20 ${
                        theme === "dark"
                          ? "bg-[#404347] text-white"
                          : "bg-white text-gray-900"
                      }`}
                    >
                      {cataGories.map((item, i) => (
                        <div
                          key={i}
                          onClick={() => {
                            setSelectedCategory(item);
                            setIsDropDownOpen(false);
                          }}
                          className={`px-3 py-2 hover:${
                            theme === "dark" ? "bg-gray-600" : "bg-gray-100"
                          } cursor-pointer`}
                        >
                          {item}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Cover Image Upload */}
                <div className="mb-4">
                  <label
                    className={`block mb-2 ${
                      theme === "dark" ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Cover Image
                  </label>
                  <input
                    type="file"
                    className={`w-full px-3 py-2 border rounded-lg ${
                      theme === "dark"
                        ? "bg-[#404347] text-white border-gray-600"
                        : "bg-white text-gray-900 border-gray-300"
                    }`}
                    onChange={handleFileChange1}
                  />
                </div>

                <div className="mb-4">
                  <label
                    className={`block mb-2 ${
                      theme === "dark" ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Alt Text of cover image
                  </label>
                  <input
                    type="text"
                    value={altText}
                    onChange={(e) => setAltText(e.target.value)}
                    className={`w-full px-3 py-2 border rounded-lg ${
                      theme === "dark"
                        ? "bg-[#404347] text-white border-gray-600"
                        : "bg-white text-gray-900 border-gray-300"
                    }`}
                  />
                </div>

                <div className="mb-4">
                  <label
                    className={`block mb-2 ${
                      theme === "dark" ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Blog Url
                  </label>
                  <input
                    type="text"
                    value={blogUrl}
                    onChange={(e) => setBlogUrl(e.target.value)}
                    className={`w-full px-3 py-2 border rounded-lg ${
                      theme === "dark"
                        ? "bg-[#404347] text-white border-gray-600"
                        : "bg-white text-gray-900 border-gray-300"
                    }`}
                  />
                </div>

                {/* Tags Field */}
                <div className="mb-4">
                  <label
                    className={`block mb-2 ${
                      theme === "dark" ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Tags
                  </label>
                  <div className="flex flex-wrap gap-2 mb-2">
                    {tags.map((tag, index) => (
                      <span
                        key={index}
                        className={`px-2 py-1 rounded flex items-center bg-gray-300 text-black`}
                      >
                        {tag}
                        <button
                          type="button"
                          onClick={() =>
                            setTags(tags.filter((_, i) => i !== index))
                          }
                          className="ml-1 hover:text-red-500 bg-transparent text-2xl shadow-none text-red-600"
                        >
                          ×
                        </button>
                      </span>
                    ))}
                  </div>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      value={newTag}
                      onChange={(e) => {
                        if (e.key === "ENTER") {
                          if (newTag?.trim()) {
                            setTags([...tags, newTag.trim()]);
                            setNewTag("");
                          }
                        }
                        setNewTag(e.target.value);
                      }}
                      className={`w-full px-3 py-2 border rounded-l-lg ${
                        theme === "dark"
                          ? "bg-[#404347] text-white border-gray-600"
                          : "bg-white text-gray-900 border-gray-300"
                      }`}
                      placeholder="Add tag"
                    />
                    <button
                      type="button"
                      onClick={() => {
                        if (newTag?.trim()) {
                          setTags([...tags, newTag.trim()]);
                          setNewTag("");
                        }
                      }}
                      className="px-4 py-2 bg-primary-green text-white rounded-md w-max "
                    >
                      Add
                    </button>
                  </div>
                </div>

                <div className="mb-4">
                  <label
                    className={`block mb-2 ${
                      theme === "dark" ? "text-gray-300" : "text-gray-700"
                    }`}
                  >
                    Keywords
                  </label>
                  <div className="flex flex-wrap gap-2 mb-2">
                    {keywords.map((keyword, index) => (
                      <span
                        key={index}
                        className={`px-2 py-1 rounded flex items-center bg-gray-300 text-black`}
                      >
                        {keyword}
                        <button
                          type="button"
                          onClick={() =>
                            setKeywords(keywords.filter((_, i) => i !== index))
                          }
                          className="ml-1 hover:text-red-500 text-2xl bg-transparent shadow-none text-red-600"
                        >
                          ×
                        </button>
                      </span>
                    ))}
                  </div>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      value={newKeyWord || ""}
                      onChange={(e) => setNewKeyword(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          if (newKeyWord?.trim()) {
                            setKeywords([...keywords, newKeyWord.trim()]);
                            setNewKeyword("");
                          }
                        }
                      }}
                      className={`w-full px-3 py-2 border rounded-l-lg ${
                        theme === "dark"
                          ? "bg-[#404347] text-white border-gray-600"
                          : "bg-white text-gray-900 border-gray-300"
                      }`}
                      placeholder="Add keywords"
                    />
                    <button
                      type="button"
                      onClick={() => {
                        if (newKeyWord?.trim()) {
                          setKeywords([...keywords, newKeyWord.trim()]);
                          setNewKeyword("");
                        }
                      }}
                      className="px-4 py-2 bg-primary-green text-white rounded-md w-max"
                    >
                      Add
                    </button>
                  </div>
                </div>

                {/* Form Actions */}
                <div className="flex justify-end gap-3 mt-6">
                  <button
                    type="button"
                    onClick={onClose}
                    className={`px-4 py-2 border rounded-full w-max border-gray-border text-black bg-transparent shadow-none hover:scale-105`}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="px-4 py-2 primary-button">
                    {isLoading ? "Publishing..." : "Publish"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogsEditor;
